import { SmileOutlined } from "@ant-design/icons";
import { Result } from "antd";
import Seller from "pages/Seller";
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { isMicroApp } from "utils/microApp";
import Box from "./Box";

const Welcome: React.FC = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("common.home")}</title>
      </Helmet>
      <Box px={3} py={6} textAlign="center">
        <Result icon={<SmileOutlined />} title={t("common.welcome_text")} />
      </Box>
    </>
  );
};

export default Welcome;
